<template>
  <div>
    <table-manager
     @filterChanged="filterChanged"
     @paginationChanged="paginationChanged"
     :options="options"
     @ClickOnAddButton="showAdd"/>

    <basic-table
    :key="rerenderTable"
      v-if="ipZoneList"
      :items="ipZoneList"
      :fields="ipZoneFields"
      :filter="filter"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :totalRows="totalRows"
      :isEdit="!hideEditButtonIPzones"/>
    <table-manager-bottom
      :totalRows="totalRows"
      :perPage="perPage"
      @input="onClickPageChange"
      v-model="currentPage"/>
    <editModal
    :editItem="currentRowIpZone"
    :perPage="perPage"
    />
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  props: {
    hideEditButtonIPzones: null,
    hideAddButton: null,
    hidePerPage: null,
    upCallEditRow: null,
    dropActions: null
  },
  data () {
    return {
      rerenderTable: 0,
      currentRowIpZone: null,
      options: {
        isShowAddButton: !this.hideAddButton,
        isDisablePerShow: this.hidePerPage
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      ipZoneFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    onClickPageChange (numPage) {
      this.currentPage = numPage
      this.$store.dispatch('ReferenceBooks/GET_IP_ZONES_PAGED', {page: this.currentPage, filter: this.filter, perPage: this.perPage})
    },
    showAdd () {
      this.currentRowIpZone = {
        id: 0,
        name: '',
        networks: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditIPzones', '#btnShow')
    },
    editItem (item) {
      let ipZone = JSON.parse(JSON.stringify(item))
      if (this.upCallEditRow) {
        this.$emit('ClickOnEditButton', ipZone)
        return
      }
      this.currentRowIpZone = ipZone
      this.$root.$emit('bv::show::modal', 'modalEditIPzones', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
      this.$store.dispatch('ReferenceBooks/GET_IP_ZONES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
    },
    paginationChanged (value) {
      this.perPage = value
      this.$store.dispatch('ReferenceBooks/GET_IP_ZONES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
    }
  },
  watch: {
    ipZoneList: function (val) {
      for (let el of val) {
        for (let elMask of el.networks) {
          elMask.network_prepared = elMask.network + '/' + elMask.mask_dec
          elMask.mask = elMask.mask_dec
        }
      }
      this.totalRows = this.$store.getters['ReferenceBooks/IP_ZONES_PAGED'].total_rows
    }
  },
  computed: {
    ipZoneList () {
      return this.$store.getters['ReferenceBooks/IP_ZONES_PAGED'].zones
    }
  },
  async mounted () {
    if (this.dropActions) {
      this.ipZoneFields = this.ipZoneFields.filter(el => { return el.key !== 'actions' })
      this.rerenderTable += 1
    }
    await this.$store.dispatch('ReferenceBooks/GET_IP_ZONES_PAGED', {page: 1, filter: this.filter, perPage: this.perPage})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/IPzone/main.vue